import styled from '@emotion/styled';
import React from 'react';
import arrowImageWhite from 'assets/images/icons/icon-arrow-link-white.svg';

type Arrow2Props = {
  arrowDir?: 'left' | 'right';
};

const Container = styled.span<Arrow2Props>`
  background-color: #1a1311;
  width: 36px;
  height: 36px;
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
`;

const ArrowBody = styled.span<Arrow2Props>`
  margin: auto;
  position: relative;
  display: block;
  width: 20px;
  height: 20px;
  background: bottom / contain no-repeat url(${arrowImageWhite});
`;

export const Arrow2: React.FC<Arrow2Props> = ({ arrowDir = 'right', ...props }) => {
  return (
    <Container>
      <ArrowBody {...props} arrowDir={arrowDir} />
    </Container>
  );
};
